import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { SearchCustomerViewModel } from "../searchCustomer/searchCustomer-viewModel";
import  { CustomerCreditView } from "./customerCredit-view"

export class CustomerCreditViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'اعتبار مشتری';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.customerCredits = ObservableArray.create<customerCredit>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new CustomerCreditView();
    }
    public getTypeId(): string {
        return "VM-D6F07179-007B-4F67-94CD-4BAC078A01F0"
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set customerCredits(v: ObservableArray<customerCredit>) { this._customerCredits = v; } public get customerCredits(): ObservableArray<customerCredit> { return this._customerCredits;} private _customerCredits: ObservableArray<customerCredit>;
    
    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CreditServices/GetAllCustomerCredit',{
                FurtherQueryInfo:filteringInformation,
            });
            this.customerCredits.update(...result.CustomerCredit.map((q,i)=>{
                let r = new customerCredit(this);
                r.rowNumber = i+1;
                r.customerCreditId = q.Id;
                r.amount = q.Amount;
                r.newAmount = q.Amount;
                r.type = q.Type;
                r.daysCount = r.type == 1 ? 'ماهانه' : q.DaysCount;
                r.allowSaleAfterDays = q.AllowSaleAfterDays;
                r.takeCreditCustomerId = q.TakeCreditCustomerId;
                r.takeCreditCustomerName = q.TakeCreditCustomerName;
                r.takeCreditCustomerCode = q.TakeCreditCustomerCode;
                r.isEdited = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async save(item:customerCredit){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/CreditServices/CreateCustomerCredit',{
                Amount : item.newAmount,
                AllowSaleAfterDays : item.allowSaleAfterDays,
                DaysCount : item.type == 1 ? 0 : item.daysCount,
                Type : item.type,
                TakeCreditCustomerId : item.takeCreditCustomerId
            });
        } catch (ex) {
            throw ex;
        } finally {
            this.isLoading = false;
        }
    }
    async create(){
        let editor = new customerCreditEditor(this);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async edit(customerCredit:customerCredit){
        let editor = new customerCreditEditor(this);
        customerCredit.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async disable(id:string){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/CreditServices/DisableCustomerCredit',{
                Id:id
            });
            await this.messageBoxConfirmSuccess('اعتبار مشتری غیر فعال شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}

export class customerCredit extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CustomerCreditViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    protected _typedParent : CustomerCreditViewModel;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set customerCreditId(v: string) { this._customerCreditId = v; } public get customerCreditId(): string { return this._customerCreditId;} private _customerCreditId: string;
    public set type(v: number) { this._type = v; } public get type(): number { return this._type;} private _type: number;
    public set daysCount(v: number) { this._daysCount = v; } public get daysCount(): number { return this._daysCount;} private _daysCount: number;
    public set allowSaleAfterDays(v: number) { this._allowSaleAfterDays = v; } public get allowSaleAfterDays(): number { return this._allowSaleAfterDays;} private _allowSaleAfterDays: number;
    public set takeCreditCustomerId(v: string) { this._takeCreditCustomerId = v; } public get takeCreditCustomerId(): string { return this._takeCreditCustomerId;} private _takeCreditCustomerId: string;
    public set takeCreditCustomerName(v: string) { this._takeCreditCustomerName = v; } public get takeCreditCustomerName(): string { return this._takeCreditCustomerName;} private _takeCreditCustomerName: string;
    public set takeCreditCustomerCode(v: string) { this._takeCreditCustomerCode = v; } public get takeCreditCustomerCode(): string { return this._takeCreditCustomerCode;} private _takeCreditCustomerCode: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set newAmount(v: number) { 
        this._newAmount = getAsNumber(v,true); 
        if (this.amount != v) {
            this.isEdited = true;
        } else {
            this.isEdited = false;
        }
    } public get newAmount(): number { return this._newAmount;} private _newAmount: number;
    public set isEdited(v: boolean) { this._isEdited = v; } public get isEdited(): boolean { return this._isEdited;} private _isEdited: boolean;
    
    async confirm(){
        let confirmation ='';
        confirmation = await this.messageBoxWarningYesNo('آیا اعتبار بروزرسانی شود؟','بروزرسانی اعتبار');
        if(confirmation=='no'){
            return;
        }
        try {
            this._typedParent.isLoading = true;
            if(this.newAmount < 0){
                await this.messageBoxConfirmWarning('اعتبار نامعتبر است.','خطا در ثبت اعتبار');
                throw "new Error";
            }
            await this._typedParent.save(this);
            this.isEdited = false;
            await this.messageBoxConfirmSuccess('اعتبار با موفقیت بروزرسانی شد.' ,'بروزرسانی اعتبار');
        } catch (ex) {
            console.log(ex);
        } finally {
            this._typedParent.isLoading = false;
        }
    }

    async disable():Promise<void>{
        let result:string; 
        result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن اعتبار');
        if(result=='yes'){
            this._typedParent.disable(this.customerCreditId);
        }
    }
    
    cloneTo(item:customerCreditEditor){
        item.customerCreditId = this.customerCreditId;
        item.takeCreditCustomerId = this.takeCreditCustomerId;
        item.takeCreditCustomerName = this.takeCreditCustomerName;
        item.takeCreditCustomerCode = this.takeCreditCustomerCode;
        item.daysCount = this.daysCount;
        item.allowSaleAfterDays = this.allowSaleAfterDays;
        item.amount = this.amount;
        item.type = this.type;
        item.isMonthly = this.type == 1;
    }

    async edit(){
        this._typedParent.edit(this);
    }  
}

export class customerCreditEditor extends customerCredit implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:CustomerCreditViewModel) {
        super(parent);
        this.customerSelector = new SearchCustomerViewModel(this);
        this.customerSelector.onSelectionChanged = x=>{
            this.takeCreditCustomerName = x.name,
            this.takeCreditCustomerCode = x.code;
            this.takeCreditCustomerId = x.id;
        };
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set customerSelector(v: SearchCustomerViewModel) { this._customerSelector = v; } public get customerSelector(): SearchCustomerViewModel { return this._customerSelector;} private _customerSelector: SearchCustomerViewModel;
    public set isMonthly(v: boolean) { 
        this._isMonthly = v; 
        this.type = v ? 1 : 2;
    } public get isMonthly(): boolean { return this._isMonthly;} private _isMonthly: boolean;
    
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.takeCreditCustomerId)){
            result.push('مشتری مشخص نشده است.')
        } 
        if(this.amount < 0){
            result.push(' اعتبار نامعتبر است.')
        }
        
        return result;
    }

    closePopup(resultCode: string = null) {
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت درخواست');
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CreditServices/CreateCustomerCredit',{
                Amount:this.amount,
                AllowSaleAfterDays:this.allowSaleAfterDays,
                DaysCount : this.type == 1 ? 0 : this.daysCount,
                Type:this.isMonthly ? 1 : 2,
                TakeCreditCustomerId:this.takeCreditCustomerId
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            await this.messageBoxConfirmSuccess('اعتبار به مشتری با موفقیت اختصاص یافت.','عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this._typedParent.refresh();
        }
    }

    back(){
        this.closePopup();
    }

}
